import * as XLSX from "xlsx";

/**
 * Export DataTable data to Excel
 * @param {Array} data - The raw data array (rows).
 * @param {Array} columns - The DataTable column definitions.
 * @param {String} fileName - The output file name.
 */
export const exportDataTableToExcel = (
  data,
  columns,
  fileName = "Export.xlsx"
) => {
  if (!data || !data.length) {
    alert("No data available to export");
    return;
  }

  // Only include columns that are not omitted
  const exportColumns = columns.filter((col) => !col.omit);

  // Headers (column names)
  const headers = exportColumns.map((col) => {
    if (typeof col.name === "string") return col.name;
    return col.id || ""; // fallback if JSX header
  });

  // Rows (values)
  const rows = data.map((row) =>
    exportColumns.map((col) => {
      if (typeof col.selector === "function") {
        try {
          return col.selector(row); // run selector if function
        } catch (e) {
          return ""; // safe fallback
        }
      }
      return row[col.id] || "";
    })
  );

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // Auto column width
  const colWidths = headers.map((h, i) => ({
    wch: Math.max(
      h.length,
      ...rows.map((r) => (r[i] ? String(r[i]).length : 0))
    ),
  }));
  worksheet["!cols"] = colWidths;

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Download file
  XLSX.writeFile(workbook, fileName);
};
